/**
 * ProfileHeader
 */
import { Avatar, Box, Grid, Hidden, makeStyles, useScrollTrigger, useTheme } from '@material-ui/core';
import { Spring, Transition } from 'react-spring/renderprops.cjs';
import { Typography } from '../Typography';
import React, { Fragment } from 'react';
import User from '../User';
const styles = (isScrolled) => makeStyles(({ breakpoints, palette, spacing, content }) => ({
    container: {
        [breakpoints.down('sm')]: {
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
        },
        position: 'sticky',
        padding: content.padding,
        paddingTop: isScrolled ? spacing(2) : content.padding,
    },
    avatarContainer: {
        position: 'relative',
    },
    avatar: {
        display: 'inline-flex',
        [breakpoints.down('xs')]: {
            marginBottom: isScrolled ? -10 : 0,
        },
    },
    title: {
        marginBottom: isScrolled ? -10 : 0,
        transition: 'all 0.3s ease',
    },
    mobileSecondaryControl: {
        position: 'absolute',
        top: spacing(2),
        right: spacing(2),
        display: 'inline-block',
        [breakpoints.up('md')]: {
            display: 'none',
        },
    },
    description: {
        margin: spacing(3),
        lineHeight: 1.25,
        [breakpoints.up('md')]: {
            margin: `0 ${spacing(1)}px`,
        },
    },
    desktopChildren: {
        justifyContent: 'flex-end',
        marginTop: spacing(-0.5),
        [breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    centerMobile: {
        [breakpoints.down('sm')]: {
            textAlign: 'center',
            margin: '0 auto',
            justifyContent: 'center',
        },
    },
    editContainer: {
        textAlign: 'right',
    },
    detailsIcons: {
        color: palette.text.secondary,
    },
}));
const ProfileHeader = props => {
    const { avatarImg, title, subtitle, details, secondaryControl, secondaryAvatarUrl, children } = props;
    const isScrolled = useScrollTrigger({ threshold: 0, disableHysteresis: true });
    const theme = useTheme();
    const classes = styles(isScrolled)();
    const transition = {
        initial: { opacity: 1, height: 'auto', overflow: 'hidden' },
        from: { opacity: 0, height: 0, overflow: 'hidden' },
        enter: { opacity: 1, height: 'auto' },
        leave: { opacity: 0, height: 0 },
    };
    const smallAvatarSize = theme.spacing(5);
    const largeAvatarSize = theme.spacing(12);
    const detailItems = details || [];
    return (React.createElement(Grid, { container: true, item: true, style: { flex: 1 }, spacing: 2, className: classes.container },
        React.createElement(Grid, { item: true, className: classes.avatarContainer },
            React.createElement(Spring, { to: { size: isScrolled ? smallAvatarSize : largeAvatarSize } }, props => (React.createElement(Fragment, null,
                React.createElement(User, { alt: "Profile Avatar", src: avatarImg, size: "large", className: classes.avatar, style: { height: props.size, width: props.size } }),
                secondaryAvatarUrl && (React.createElement(Avatar, { src: secondaryAvatarUrl, style: {
                        position: 'absolute',
                        height: props.size / 2,
                        width: props.size / 2,
                        right: props.size * 0,
                        top: props.size * 0.7,
                        zIndex: 100,
                    } })))))),
        secondaryControl && React.createElement(Box, { className: classes.mobileSecondaryControl }, secondaryControl),
        React.createElement(Grid, { item: true, container: true, style: { flex: 1 }, className: classes.centerMobile },
            React.createElement(Grid, { item: true, style: { flex: 1, flexWrap: 'nowrap' } },
                title && (React.createElement(Typography, { variant: "h4", color: "secondary", className: classes.title }, title)),
                subtitle && React.createElement(Typography, { variant: isScrolled ? 'caption' : 'subtitle1' }, subtitle)),
            React.createElement(Grid, { container: true, item: true, xs: 4, className: classes.desktopChildren }, children),
            React.createElement(Grid, { container: true }, detailItems.map(({ icon, content }, index) => {
                return (React.createElement(Transition, Object.assign({ items: !isScrolled }, transition, { key: index }), show => show &&
                    (transitionProps => (React.createElement(Grid, { container: true, className: classes.centerMobile, spacing: 1, style: { ...transitionProps } },
                        React.createElement(Grid, { item: true, className: classes.detailsIcons }, icon),
                        React.createElement(Grid, { item: true },
                            React.createElement(Typography, { variant: "subtitle1", color: "textSecondary", fontWeight: "light" }, content)))))));
            })),
            React.createElement(Hidden, { mdUp: true, implementation: "css" },
                React.createElement(Box, { className: classes.centerMobile, hidden: isScrolled }, children))),
        secondaryControl && (React.createElement(Hidden, { smDown: true, implementation: "css" },
            React.createElement(Grid, { item: true, className: classes.editContainer }, secondaryControl)))));
};
export default ProfileHeader;
//# sourceMappingURL=ProfileHeader.js.map